
import { Col, ColType, Crud, CrudApi } from "../../comp/crud";
import { ApiClient } from "../../api/ApiClient";

import { Form, Modal, Typography, Tag, Tabs, TabPane, Row, Col as RowCol, Banner, Highlight, Button, Switch, Tooltip as SemiTooltip } from "@douyinfe/semi-ui";
import { formatAmountZhCn, formatDate } from "../../utils";
import React, { useState, useEffect, useRef } from "react";
import PlanRepaymentReportDetail from "./planRepaymentReportDetail";
import { PlanRepaymentReportDetailProps } from "./planRepaymentReportDetail";
import MonthDrillDownModal from "./monthDrillDownModal";
import {
  IconUserGroup,
  IconUser,
  IconModalStroked,
  IconRefresh,
} from "@douyinfe/semi-icons";
import PlanRepaymentOverview from "./planRepaymentOverview";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import h4 from "@douyinfe/semi-ui/lib/cjs/markdownRender/components/h4";

const apiClient = ApiClient.getDefault();

export interface PlanRepaymentReportProps {
  entityKey?: string;
  name?: string;
  reportType?: string;
}


export default function PlanRepaymentReport(props:PlanRepaymentReportProps) {
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const crudApiRef = useRef<CrudApi | undefined>(undefined);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [planRepaymentReportDetailProps, setPlanRepaymentReportDetailProps] =
    useState(undefined as undefined | PlanRepaymentReportDetailProps);
  const [showMonthDrillDown, setShowMonthDrillDown] = useState(false);
  const [drillDownYearMonth, setDrillDownYearMonth] = useState('');
  const [drillDownLeadId, setDrillDownLeadId] = useState(undefined as undefined | number);
  const [showOverview, setShowOverview] = useState(true);
  const [summaryRow, setSummaryRow] = useState(null as any);

  const sourceString =
    "待还款金额：红色字体，已还款金额：黑色";
  const searchWords = ["红色", "黑色"];
  let titleName = "已还";
  if (props.reportType == "PlanRepaymentReportCustomer") {
    titleName = "客已还";
  }

  //获取当前月份
  let now = new Date();
  let year = now.getFullYear();
  let month = now.getMonth() + 1;
  const getNextMonth = (index: number) => {
    let nextMonth = month + index > 12 ? month + index - 12 : month + index;
    return nextMonth;
  };
  const getYearMonth = (index: number) => {
    let m = month + index;
    let y = year;
    if (m > 12) { m -= 12; y += 1; }
    return `${y}-${String(m).padStart(2, '0')}`;
  };
  const paidMethodCode = props.reportType === "PlanRepaymentReportAgent" ? "DH" : "KHZH";

  let cols: Col[] = [
    {
      name: "客户ID",
      width: 100,
      showInFilter: true,
      hideInList: true,
      key: "leadId",
      type: ColType.STRING,
      
    },
    {
      name: "客户姓名",
      width: 100,
      showInFilter: true,
      key: "leadName",
      type: ColType.STRING,
      render: (value, record, index) => {
        if(value != '汇总'){
        return (
          <Typography.Text
            link
            onClick={() => {
              openPlanRepaymentDetailModal(record.leadId);
            }}
          >
            {value}({record.leadId})
          </Typography.Text>
        )
      } else{
        return (<Typography.Title heading={4}>
            {value}
          </Typography.Title>);
      }
      },
    },
    {
        name: "城市",
        key: "leadCity",
        width: 40,
        type: ColType.SELECT,
        getOptions: () => apiClient.getDictAsOpts("city"),
        hideInList: true,
        hideInCreate: true,
         showInFilter: true,
    
    },
    {
          name: "按揭主管",
          key: "agentManager",
          width: 80,
          hideInCreate: true,
          hideInList: true,
          showInFilter: true,
          type: ColType.SELECT,
          getOptions: () => apiClient.getTeamAgentsAsOpts("agentManager"),
        },
    {
      name: "按揭专员",
      width: 100,
      showInFilter: true,
      key: "agentName",
      type: ColType.STRING,
    },
    {
      name: "贷款金额",
      width: 100,
      showInFilter: false,
      key: "loanAmount",
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "累计还款",
      width: 100,
      showInFilter: false,
      key: "paidAmount",
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: "待还金额",
      width: 100,
      showInFilter: false,
      key: "unpaidAmount",
      type: ColType.NUMBER,
      render: (a) => formatAmountZhCn(a),
    },
    {
      name: month + "月待还 | "+titleName,
      width: 160,
      showInFilter: false,
      key: "month1Amount",
      type: ColType.STRING,
      render: (value, record, index) => {
        const openDrillDown = () => { setDrillDownLeadId(record.leadId); setDrillDownYearMonth(getYearMonth(0)); setShowMonthDrillDown(true); };
        return (<>
          <Tag style={{ width: 75, cursor: 'pointer' }} color="red" onClick={openDrillDown}>{formatAmountZhCn(record.month1Amount)}</Tag>
          <Tag style={{ width: 75, cursor: 'pointer' }} color="white" onClick={openDrillDown}>{formatAmountZhCn(record.month1PaidAmount)}</Tag>
          </>
        );
      },
    },
    {
      name: getNextMonth(1) + "月待还 | "+titleName,
      width: 160,
      showInFilter: false,
      key: "month2Amount",
      type: ColType.STRING,
      render: (value, record, index) => {
        const openDrillDown = () => { setDrillDownLeadId(record.leadId); setDrillDownYearMonth(getYearMonth(1)); setShowMonthDrillDown(true); };
        return (<>
          <Tag style={{ width: 75, cursor: 'pointer' }} color="red" onClick={openDrillDown}>{formatAmountZhCn(record.month2Amount)}</Tag>
          <Tag style={{ width: 75, cursor: 'pointer' }} color="white" onClick={openDrillDown}>{formatAmountZhCn(record.month2PaidAmount)}</Tag>
          </>
        );
      },
    },
    {
      name: getNextMonth(2) + "月待还 | "+titleName,
      width: 160,
      showInFilter: false,
      key: "month3Amount",
      type: ColType.STRING,
      render: (value, record, index) => {
        const openDrillDown = () => { setDrillDownLeadId(record.leadId); setDrillDownYearMonth(getYearMonth(2)); setShowMonthDrillDown(true); };
        return (<>
          <Tag style={{ width: 75, cursor: 'pointer' }} color="red" onClick={openDrillDown}>{formatAmountZhCn(record.month3Amount)}</Tag>
          <Tag style={{ width: 75, cursor: 'pointer' }} color="white" onClick={openDrillDown}>{formatAmountZhCn(record.month3PaidAmount)}</Tag>
          </>
        );
      },
    },
    {
      name: getNextMonth(3) + "月待还 | "+titleName,
      width: 160,
      showInFilter: false,
      key: "month4Amount",
      type: ColType.STRING,
      render: (value, record, index) => {
        const openDrillDown = () => { setDrillDownLeadId(record.leadId); setDrillDownYearMonth(getYearMonth(3)); setShowMonthDrillDown(true); };
        return (<>
          <Tag style={{ width: 75, cursor: 'pointer' }} color="red" onClick={openDrillDown}>{formatAmountZhCn(record.month4Amount)}</Tag>
          <Tag style={{ width: 75, cursor: 'pointer' }} color="white" onClick={openDrillDown}>{formatAmountZhCn(record.month4PaidAmount)}</Tag>
          </>
        );
      },
    },
    {
      name: getNextMonth(4) + "月待还 | "+titleName,
      width: 160,
      showInFilter: false,
      key: "month5Amount",
      type: ColType.STRING,
      render: (value, record, index) => {
        const openDrillDown = () => { setDrillDownLeadId(record.leadId); setDrillDownYearMonth(getYearMonth(4)); setShowMonthDrillDown(true); };
        return (<>
          <Tag style={{ width: 75, cursor: 'pointer' }} color="red" onClick={openDrillDown}>{formatAmountZhCn(record.month5Amount)}</Tag>
          <Tag style={{ width: 75, cursor: 'pointer' }} color="white" onClick={openDrillDown}>{formatAmountZhCn(record.month5PaidAmount)}</Tag>
          </>
        );
      },
    },
    {
      name: getNextMonth(5) + "月待还 | "+titleName,
      width: 160,
      showInFilter: false,
      key: "month6Amount",
      type: ColType.STRING,
      render: (value, record, index) => {
        const openDrillDown = () => { setDrillDownLeadId(record.leadId); setDrillDownYearMonth(getYearMonth(5)); setShowMonthDrillDown(true); };
        return (<>
          <Tag style={{ width: 75, cursor: 'pointer' }} color="red" onClick={openDrillDown}>{formatAmountZhCn(record.month6Amount)}</Tag>
          <Tag style={{ width: 75, cursor: 'pointer' }} color="white" onClick={openDrillDown}>{formatAmountZhCn(record.month6PaidAmount)}</Tag>
          </>
        );
      },
    },
    // {
    //   name: getNextMonth(5) + "月已还",
    //   width: 75,
    //   showInFilter: false,
    //   key: "month6PaidAmount",
    //   type: ColType.STRING,
     
    // },
  ];

  const openPlanRepaymentDetailModal = async (leadId: number) => {
    let p: PlanRepaymentReportDetailProps = {
      reportType: props.reportType,
      leadId: leadId,
    };
    setPlanRepaymentReportDetailProps(p);
    setShowDetailModal(true);
  };

  return (
    <>

          <Modal
            icon={
              <IconModalStroked
                size={"extra-large"}
                style={{ color: "blue" }}
              />
            }
            fullScreen
            style={{ height: "100px" }}
            title="客户月待还款"
            visible={showDetailModal}
            hasCancel={false}
            onCancel={() => setShowDetailModal(false)}
            okType="tertiary"
            okText="关闭"
            onOk={() => setShowDetailModal(false)}
            contentStyle={{ overflow: "auto" }}
            bodyStyle={{
              height: "100%",
              padding: 0,
              overflow: "hidden", // 父级隐藏滚动条，由内容自己管理
            }}
          >
            <PlanRepaymentReportDetail
              reportType={planRepaymentReportDetailProps?.reportType}
              leadId={planRepaymentReportDetailProps?.leadId}
            ></PlanRepaymentReportDetail>
          </Modal>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
            <div />
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 13, color: '#666' }}>趋势图</span>
              <Switch checked={showOverview} onChange={setShowOverview} size="small" />
            </div>
          </div>

          {showOverview && (
            <PlanRepaymentOverview
              summaryRow={summaryRow}
              currentMonth={month}
              currentYear={year}
              onMonthClick={(ym) => {
                setDrillDownLeadId(undefined);
                setDrillDownYearMonth(ym);
                setShowMonthDrillDown(true);
              }}
            />
          )}

          <Crud
            getCrudApi={(crudApi) => {
              setCrudApi(crudApi);
              crudApiRef.current = crudApi;
            }}
            fetchDataAfterMethod={() => {
              const data = crudApiRef.current?.getData();
              if (data && data.length > 0) {
                const sum = data.find((r: any) => r.leadName === '汇总');
                setSummaryRow(sum || null);
              }
            }}
            canExport={true}
            name={props.name}
            entityKey={props.entityKey}
            pageSize={500}
            rowActionWidth={0}
            cols={cols}
          />

          <MonthDrillDownModal
            visible={showMonthDrillDown}
            yearMonth={drillDownYearMonth}
            paidMethod={paidMethodCode}
            reportType={props.reportType || ''}
            leadId={drillDownLeadId}
            onClose={() => setShowMonthDrillDown(false)}
          />
    </>
  );
}

